// extracted by mini-css-extract-plugin
module.exports = {"priceFilter":"_3fwnf9gP5Xe22-COiYLXr5","priceFields":"_3oNtVXm4cYTlDoei4wkaKs"};